// Editable row for an IntegratorMappingValueType — the declared vocabulary of the
// mapping's rules: the valueType name (what rules store and the integration's code
// asks for) and its display title. Order is not typed — rows drag-reorder and the
// VC renumbers orderIndex from the visual order.
class IntegratorMappingValueTypeCell extends UITableViewCell
{
    private nameTextField: MUITextField = null;
    private titleTextField: MUITextField = null;
    private kindComboBox: MUIComboBox = null;

    awakeFromHTML() {
        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnChangeText(this, function(this:IntegratorMappingValueTypeCell, tf: MUITextField, value: string) {
            this._item.name = value.trim();
        });

        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        this.titleTextField.setOnChangeText(this, function(this:IntegratorMappingValueTypeCell, tf: MUITextField, value: string) {
            this._item.title = value.trim();
        });

        // What a rule of this type resolves to: a single result (an Opera code, or an
        // internal category / revenue center picked from the vocabulary) or multiple
        // results (a category split — sub-cells of categorization + value).
        this.kindComboBox = MUIOutlet(this, "kind-cb", "MUIComboBox");
        this.kindComboBox.removeAllItems();
        this.kindComboBox.addItem(MIOLocalizeString("KIND_CODE", "single — code (free value)"), "code");
        this.kindComboBox.addItem(MIOLocalizeString("KIND_CATEGORY", "single — category"), "category");
        this.kindComboBox.addItem(MIOLocalizeString("KIND_REVENUE_CENTER", "single — revenue center"), "revenueCenter");
        this.kindComboBox.addItem(MIOLocalizeString("KIND_CATEGORY_SPLIT", "multiple — category split"), "categorySplit");
        this.kindComboBox.setOnChangeAction(this, function(this:IntegratorMappingValueTypeCell, cb: MUIComboBox, value: string) {
            let ui = this._item.userInfo != null ? this._item.userInfo : {};
            ui["valueKind"] = value;
            this._item.userInfo = ui;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item: IntegratorMappingValueType = null;
    set item(item: IntegratorMappingValueType) {
        this._item = item;

        this.nameTextField.text = item.name || "";
        this.titleTextField.text = item.title || "";
        let ui = item.userInfo;
        let kind = ui != null && ui["valueKind"] != null ? ui["valueKind"] : "code";
        this.kindComboBox.selectItem(kind);
    }
}
